export const SET_CURRENT_POST = 'SET_CURRENT_POST';
export const SET_USER_COMPLETED_EVENT_TASKS = 'SET_USER_COMPLETED_EVENT_TASKS';
export const SET_TOTAL_EVENT_TASKS = 'SET_TOTAL_EVENT_TASKS';
export const SET_TOTAL_EVENT_TASKS_LOADING = 'SET_TOTAL_EVENT_TASKS_LOADING';
export const SET_EVENT_TASKS = 'SET_EVENT_TASKS';
export const SET_IS_PROGRAM_TEEM = 'SET_IS_PROGRAM_TEEM';
export const SET_IS_BUBBLE_OPEN = 'SET_IS_BUBBLE_OPEN'

export const setTasks = (value: any) => {
    return { type: SET_EVENT_TASKS, value }
}

export const setUserCompletedEventTasks = (value: any) => {
    return { type: SET_USER_COMPLETED_EVENT_TASKS, value }
}

export const setTotalEventTasks = (value: any) => {
    return { type: SET_TOTAL_EVENT_TASKS, value }
}

export const setTotalEventTasksLoading = (value: any) => {
    return { type: SET_TOTAL_EVENT_TASKS_LOADING, value }
}

export const setIsProgramTeam = (value: boolean) => {
    return { type: SET_IS_PROGRAM_TEEM, value }
}

export const setCurrentPost = (value: any) => {
    return { type: SET_CURRENT_POST, value }
}

export const setIsBubbleOpen = (value: boolean) => {
    return { type: SET_IS_BUBBLE_OPEN, value }
}